export const CHECK_AUTH = {
  BEGIN: 'CHECK_AUTH_BEGIN',
  SUCCESS: 'CHECK_AUTH_SUCCESS',
  FAILURE: 'CHECK_AUTH_FAILURE'
}
